import { FC } from 'react';
import { useRouter } from 'next/router';
import { Text } from '@mofid-securities/uikit';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import { Divider } from '@/components/Divider';
import { TRedirectData } from '../../types';

interface IPendingValidationBottomsheetProps {
  currentStepPayload: TRedirectData;
}

const PendingValidationBottomsheet: FC<IPendingValidationBottomsheetProps> = ({
  currentStepPayload,
}) => {
  const router = useRouter();
  const handleCtaAction = () => {
    BottomSheet.close();
    router.push('/auth/complete-register');
  };

  return (
    <div className="flex flex-col gap-y-4">
      <Text color="gray-120" size="sm" weight="regular">
        {currentStepPayload?.message?.message}
      </Text>
      <Divider />
      <div className="flex flex-col gap-y-2 md:flex-row md:gap-x-2">
        <Button
          className="w-full md:w-1/2"
          isFullWidth
          onClick={handleCtaAction}
        >
          ادامه
        </Button>
      </div>
    </div>
  );
};

export const openPendingValidationBottomsheet = (
  currentStepPayload: TRedirectData
) => {
  return BottomSheet.open({
    children: (
      <PendingValidationBottomsheet currentStepPayload={currentStepPayload} />
    ),
    closeAction: () => {},
  });
};
